import Ajax from "base/Ajax";

export default class GalleryHelper {
    static async get_gallery(page, galleryName, cache = true) {
        if (!cache || !GalleryHelper.gallery_cache[page] || !GalleryHelper.gallery_cache[page][galleryName]) {
            if (!GalleryHelper.gallery_cache[page]) {
                GalleryHelper.gallery_cache[page] = {};
            }
            GalleryHelper.gallery_cache[page][galleryName] = Ajax.get('lb/v1', 'gallery/get', {
                page: page,
                galleryName: galleryName,
            }, Ajax.WEBSITE);
        }

        return GalleryHelper.gallery_cache[page][galleryName];
    }
}

GalleryHelper.gallery_cache = {};